import React from "react";
import PropTypes from "prop-types";
import config from "config/config.js";

import "assets/scss/material-dashboard-pro-react/plugins/_plugin-react-datepicker.css";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";

// react component for creating dynamic tables
// @material-ui/core components
// import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import search from "api/search/search.js";
import HomeMap from "view3/HomeMap.js";

// core components
import SearchInput from "componentCustom/SearchInput.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

Object.assign(styles, {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  restaurantName: {
    textAlign: "center"
  }
});

export default function Main(props) {
  const { updateCity } = props;
  return (
    <div className="main-banner-home">
      <HomeMap updateCity={updateCity} />
      <div className="main-banner-content">
        {/* <div className="search-container">
          <SearchInput
            getElementSelected={elem => {
              updateCity(elem);
              if (elem.alias) {
                window.location.href = `${config.clientUrl}/restaurant?${elem.alias}`;
              } else {
                window.location.href = `${config.clientUrl}/search?${
                  elem.latitude
                }@${elem.longitude}&${elem.name.replace(/\s/g, "-")}`;
              }
            }}
            search={(elem, timestamp) => {
              return search("13.9027424", "42.9118137", "it", elem, timestamp);
            }}
          />
        </div> */}
      </div>
    </div>
  );
}
Main.propTypes = {
  updateCity: PropTypes.func.isRequired,
  city: PropTypes.object.isRequired
};
